import { DetailedHTMLProps, FC, ForwardedRef, HTMLAttributes, MouseEvent, forwardRef } from 'react';
import { useAccordianContext } from '../context/accordian-context';
import { twMerge } from 'tailwind-merge';
import AccordianIcon from './AccordianIcon';

interface AccordianHeaderProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ref?: ForwardedRef<HTMLDivElement>;
    showIcon?: boolean;
}

const AccordianHeader = forwardRef((props: AccordianHeaderProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { children, showIcon, className, onClick, ...rest } = props;

    const { setIsExpanded } = useAccordianContext();

    const handleClick = (e: MouseEvent<HTMLDivElement>) => {
        setIsExpanded((prev) => !prev);
        onClick?.(e);
    };

    return (
        <div
            {...rest}
            ref={ref}
            className={twMerge('flex items-center justify-between font-medium select-none cursor-pointer', className)}
            onClick={handleClick}
        >
            {children}

            {showIcon && <AccordianIcon />}
        </div>
    );
});

AccordianHeader.defaultProps = {
    showIcon: true,
};

export default AccordianHeader;
